export default __webpack_public_path__ + "static/media/door-hanger-up-close.962aa643.png";